import { render, staticRenderFns } from "./compIntro.vue?vue&type=template&id=7b0098b6&scoped=true"
import script from "./compIntro.vue?vue&type=script&lang=js"
export * from "./compIntro.vue?vue&type=script&lang=js"
import style0 from "./compIntro.vue?vue&type=style&index=0&id=7b0098b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0098b6",
  null
  
)

export default component.exports